<template>
    <div>
        <div class="navbar-wrapper" :style="navbarStyles">
            <Navbar :showLoginModal="showLoginModal"/>
        </div>
        <MobileBanner v-if="isMobile" />
        <DesktopBanner v-else />
        <!-- Recommended Classes -->
        <div class="section">
            <h4>All courses</h4>
            <div id="container" class="row-wrap">
                <div id="card-container" v-for="(course, index) in courses" :key="index">
                    <CourseCard
                        v-if="course.visible"
                        :id="course.id"
                        :code="course.code"
                        :credits="course.credits"
                        :rating="course.ratingSums['overall'] / course.numReviews"
                        :title="course.name"
                        :numReviews="course.numReviews"
                        :courseIcon="course.icon"
                        :color="course.color"
                    />
                </div>
            </div>
        </div>

        <Footer />
    </div>
</template>

<script>
import Navbar from "@/components/navigation/Navbar";
import Footer from "@/components/navigation/Footer";
import MobileBanner from "@/components/banners/HomeBannerMobile";
import DesktopBanner from "@/components/banners/HomeBannerDesktop";
import CourseCard from "@/components/cards/CourseCard";
import { firestore } from "@/firebase.js";

const breakpoint = 1000;

export default {
    // This is the name of our component
    name: "HomePage",

    props: {
        showLoginModal: {
            type: Boolean,
            default: false
        }
    },

    // This is all of the components that we use
    components: {
        CourseCard,
        MobileBanner,
        DesktopBanner,
        Navbar,
        Footer,
    },

    // These are the "fields" or data that this object stores
    data() {
        return {
            courses: [],
            width: window.innerWidth,
        };
    },



    computed: {
        isMobile() {
            return this.width <= breakpoint;
        },
        navbarStyles() {
            let color = this.isMobile ? "#ffc4b7" : "";
            return {
                background: color,
            };
        },
    },

    // Connect our data to our visible firestore collections and documents
    firestore: {
        courses: firestore
            .collection("university")
            .doc("uw")
            .collection("courses")
            .where("visible", "==", true),
    },

    methods: {
        handleResize() {
            this.width = window.innerWidth;
        },
    },

    created() {
        window.addEventListener("resize", this.handleResize);
    },

    destroyed() {
        window.removeEventListener("resize", this.handleResize);
    },
};
</script>

<style lang="scss" scoped>
@import "@/styles/_main.scss";

.section {
    padding: 52px 8% 101px 8%;
}

#container {
    display: grid;
    grid-template-columns: repeat(auto-fill, 300px);
    grid-column-gap: 2rem;
    grid-row-gap: 2rem;
    margin: 22px 0 0 0;
}

h4 {
    font-weight: bold;
}

@media only screen and (max-width: $breakpoint-medium) {
    .title {
        padding-top: 20px;
        padding-bottom: 20px;
    }

    .subtitle {
        display: none;
    }

    #container {
        justify-content: center;
    }
}
</style>
